import React from 'react';

export const DATE_RANGES = [
  { key: 'all', label: 'All Time' },
  { key: 'week', label: 'This Week' },
  { key: 'month', label: 'This Month' },
  { key: '30d', label: 'Last 30 Days' },
];

// Filter a list of items by a date field using a range key.
// `getDate` is a function that returns the date string from the item.
export const filterByDateRange = (items, rangeKey, getDate = (item) => item?.date) => {
  if (!items) return [];
  if (rangeKey === 'all') return items;

  const now = new Date();
  let startDate;

  if (rangeKey === 'week') {
    // Start of the current week (Sunday)
    const day = now.getDay();
    startDate = new Date(now);
    startDate.setDate(now.getDate() - day);
    startDate.setHours(0, 0, 0, 0);
  } else if (rangeKey === 'month') {
    startDate = new Date(now.getFullYear(), now.getMonth(), 1);
    startDate.setHours(0, 0, 0, 0);
  } else if (rangeKey === '30d') {
    startDate = new Date(now);
    startDate.setDate(now.getDate() - 30);
    startDate.setHours(0, 0, 0, 0);
  } else {
    return items;
  }

  return items.filter((item) => {
    const dateStr = getDate(item);
    if (!dateStr) return false;
    const d = dateStr.includes('/') ? new Date(dateStr) : new Date(dateStr + 'T00:00:00');
    return d >= startDate;
  });
};

const DateFilter = ({ value, onChange, className = '' }) => {
  return (
    <div
      className={`inline-flex rounded-lg border overflow-hidden ${className}`}
      style={{ borderColor: 'var(--color-border)' }}
      role="tablist"
      aria-label="Date range filter"
    >
      {DATE_RANGES.map((range) => {
        const active = value === range.key;
        return (
          <button
            key={range.key}
            role="tab"
            aria-selected={active}
            className="px-3 py-1.5 font-caption text-xs font-medium transition-all whitespace-nowrap"
            style={{
              backgroundColor: active ? 'var(--color-primary)' : 'transparent',
              color: active ? '#fff' : 'var(--color-muted-foreground)',
            }}
            onClick={() => onChange(range.key)}
          >
            {range.label}
          </button>
        );
      })}
    </div>
  );
};

export default DateFilter;
